const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
    <style>
        .item-webinar-container {
            background: #ffffff;
            border-radius: 5px;
            box-shadow: 0px 1px 10px rgb(66 66 66 / 15%);
            display: flex;
            margin-bottom: 15px;
            cursor: pointer;
        }

        .webinar-schdule-continer {
            display: flex;
            margin-bottom: 8px;
            flex-direction: initial;
        }

        .webinar-series-indicator{
            display: flex;
            align-items: center;
        }

        .webinar-series-indicator img {
            margin-right: 6px;
        }

        .webinar-series-indicator p {
            margin: 0;
            font-size: 14px;
            line-height: 20px;
            color: #3570D2;
            font-weight: 700;
        }

        .line-grey{
            height: 14px;
            background-color: #ECECEC;
            width: 1.5px;
            border: none;
            margin: 0 8px;
        }

        .sponsore-channel-container {
            margin-bottom: 16px;
            display: flex;
        }

        .sponsore-channel-container img{
            width: 32px;
            height: 32px;
            border: 1px solid #D9D9D9;
            border-radius: 50%;
            margin-right: 8px;
            object-fit: contain;
        }

        .sponsore-channel-container p{
            margin: 0px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2; /* number of lines to show */
            -webkit-box-orient: vertical;
        }

        .sponsore-channel-title {
            display: inline-block;
        }

        .sponsore-category {
            font-size: 12px;
            color: #7F7F7F;
            font-weight: 400;
            line-height: 16px;
        }

        .sponsore-name {
            font-size: 14px;
            color: #424242;
            font-weight: 600; 
            line-height: 19px;
        }

        .thumbnail-webinar {
            width: 280px;
            position: relative;
        }

        .thumbnail-webinar img{
            width: 280px;
            min-height: 100%;
            object-fit: cover;
            height: 115px;
        }

        .webinar-status-container {
            position: absolute;
            right: 0;
            bottom: 0;
            padding: 8px;
            border-radius: 12px 0 0 0;
            min-width: 140px;
            font-size: 14px;
            color: white;
            font-weight: 400;
            text-align: center;
            opacity: 0.9;
            line-height: 20px;
        }

        .orange-label {
            background-color: #F96D01;
        }

        .green-label {
            background-color: #559808;
        }

        .black-label {
            background-color: #424242;
        }
        
        .detail-webinar {
            padding: 16px;
            flex: 1;
        }

        .webinar-schdule {
            margin: 0;
            color: #3570D2;
            font-weight: 400;
            font-size: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2; /* number of lines to show */
            -webkit-box-orient: vertical;
            line-height: 20px;
            flex: 1;
        }

        .webinar-title {
            margin: 0 0 8px 0;
            color: #4A4A4A;
            font-size: 18px;
            font-weight: 600;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2; /* number of lines to show */
            -webkit-box-orient: vertical;
            line-height: 24px;
        }

        .webinar-skp-price-container{
            display: flex;
            align-items: center;
        }

        .webinar-skp-price-container img{
            margin-right: 4px;
        }

        .webinar-skp-price-container .skp-point{
            color: #F5A623;
            font-size: 18px;
            font-weight: 600;
            margin: 0px;
            line-height: 19px;
        }

        .webinar-skp-price-container p{
            margin: 0;
            border: 1px solid #ED6700;
            border-radius: 4px;
            padding: 4px 12px;
            font-size: 14px;
            font-weight: 600;
            color: #ED6700;
            margin-left: auto;
            line-height: 19px;
        }

        .webinar-skp-price-container .strikethrough-price{
            color: #7F7F7F;
            text-decoration: line-through;
        }

        .webinar-share-register{
            display: flex;
            margin-top: 16px;
        }

        .webinar-share-button-text {
            font-size: 18px;
            font-weight: 600;
            color: #595959;
            margin: 0;
            cursor: pointer;
            line-height: 24px;
        }

        .webinar-share-button {
            display: flex;
            align-items: center;
        }

        .webinar-share-button img {
            width: 18px;
            margin-right: 4px;
        }

        .webinar-register-button {
            display: flex;
            background-color: #ED6700;
            width: 174px;
            border-radius: 4px;
            align-items: center;
            justify-content: center;
            height: 42px;
            margin-left: auto;
            cursor: pointer;
        }

        .webinar-register-button img {
            width: 18px;
            height: 18px;
        }

        .webinar-register-button p {
            font-size: 16px;
            margin: 0px;
            color: white;
            font-weight: 600;
            line-height: 22px;
        }
    </style>
</template>`;
styleElement.register("webinar-card-search-style");
